import { useAuthStore } from '@/store/auth'
import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

const casaCampanaPrivateApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
}) 

casaCampanaPrivateApi.interceptors.request.use(async config => {
  const { logout } = useAuthStore()
  try {

    const token = localStorage.getItem("cc-user-token")
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`

    } else {
      logout()
    }
  } catch (err) {
      
    logout()
  }

  return config
})

export default casaCampanaPrivateApi
